export default "__VITE_ASSET__BhzTTnA8__"